<template>
<div class="chapter">
<div class="inner_page">
<div class="figcenter1">
<img alt="Frontispiece" class="calibre16" id="id-2208187964854764959" src="Images/img0009.jpg" title=""/>
<span class="caption" id="ebm_caption0">the pursuit of the train robber.</span>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?5b312012